/* ==========================================================================
   31st — Product page
   Variant selection, media gallery, quantity and zoom.
   ========================================================================== */
(function () {
  'use strict';

  var S = (window.st31 && window.st31.strings) || {};

  function initProduct(root) {
    if (!root || root.dataset.st31Init === 'true') return;
    root.dataset.st31Init = 'true';

    var dataEl = root.querySelector('[data-st31-variant-data]');
    var variants = [];
    if (dataEl) {
      try { variants = (JSON.parse(dataEl.textContent) || {}).variants || []; } catch (e) { variants = []; }
    }

    var idInput   = root.querySelector('[data-st31-variant-id]');
    var priceEl   = root.querySelector('[data-st31-price]');
    var skuWrap   = root.querySelector('[data-st31-sku]');
    var skuValue  = root.querySelector('[data-st31-sku-value]');
    var addBtn    = root.querySelector('[data-st31-add]');
    var addLabel  = root.querySelector('[data-st31-add-label]');
    var form      = root.querySelector('.st31-pdp__form');

    /* ------------------------------------------------------ variant match */
    function selectedOptions() {
      var groups = root.querySelectorAll('.st31-variants__group');
      return Array.prototype.map.call(groups, function (group) {
        var checked = group.querySelector('.st31-variants__input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return options.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function setAddState(variant) {
      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = S.unavailable || 'Unavailable';
      } else if (!variant.available) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = S.soldOut || 'Sold out';
      } else {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = addBtn.dataset.defaultLabel || S.addToCart || 'Add to cart';
      }
    }

    function syncStickyBar(variant) {
      var bar = document.querySelector('[data-st31-sticky-atc]');
      if (!bar) return;

      // Remember the label the merchant set before the first swap overwrites it
      var stickyBtn = bar.querySelector('[data-st31-add]');
      var stickyLbl = bar.querySelector('[data-st31-add-label]');
      if (stickyBtn && stickyLbl && !stickyBtn.dataset.defaultLabel) {
        stickyBtn.dataset.defaultLabel = stickyLbl.textContent.trim();
      }

      var barPrice = bar.querySelector('[data-st31-sticky-price]');
      if (barPrice && variant && variant.price_html) barPrice.innerHTML = variant.price_html;

      var barBtn = bar.querySelector('[data-st31-add]');
      var barLabel = bar.querySelector('[data-st31-add-label]');
      if (barBtn) {
        var ok = !!(variant && variant.available);
        barBtn.disabled = !ok;
        if (barLabel) {
          barLabel.textContent = ok
            ? (barBtn.dataset.defaultLabel || S.addToCart || 'Add to cart')
            : (S.soldOut || 'Sold out');
        }
      }
    }

    /* Reads live Shopify inventory. Stays hidden unless stock is actually
       tracked for this variant and sits at or below the merchant's threshold. */
    function syncStock(variant) {
      var box = root.querySelector('[data-st31-stock]');
      if (!box) return;

      var label = box.querySelector('[data-st31-stock-text]');
      var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 0;
      var tracked = !!(variant && variant.inventory_managed);
      var qty = variant ? Number(variant.inventory_quantity) : 0;

      if (!tracked || qty <= 0 || qty > threshold) { box.hidden = true; return; }

      box.hidden = false;
      if (label) {
        var tpl = S.onlyLeft || 'Last %count% available';
        label.textContent = tpl.replace('%count%', qty);
      }
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var items = root.querySelectorAll('[data-st31-media]');
      var match = null;

      items.forEach(function (item) {
        var isMatch = item.getAttribute('data-media-id') === String(mediaId);
        item.setAttribute('data-active', isMatch ? 'true' : 'false');
        if (isMatch) match = item;
      });

      root.querySelectorAll('[data-st31-thumb]').forEach(function (thumb) {
        var isMatch = thumb.getAttribute('data-st31-thumb') === String(mediaId);
        thumb.setAttribute('data-active', isMatch ? 'true' : 'false');
        thumb.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      });

      // On mobile the stage is a swipeable track, so bring the slide into view
      var stage = root.querySelector('[data-st31-gallery-stage]');
      if (match && stage && stage.scrollWidth > stage.clientWidth + 4) {
        stage.scrollTo({ left: match.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      }
    }

    function update() {
      var options = selectedOptions();
      var variant = findVariant(options);

      // Reflect the chosen value next to each option's name
      options.forEach(function (val, i) {
        var label = root.querySelector('[data-st31-option-value="' + (i + 1) + '"]');
        if (label && val) label.textContent = val;
      });

      if (idInput && variant) idInput.value = variant.id;
      if (priceEl && variant && variant.price_html) priceEl.innerHTML = variant.price_html;

      if (skuWrap) {
        var hasSku = !!(variant && variant.sku);
        skuWrap.hidden = !hasSku;
        if (hasSku && skuValue) skuValue.textContent = variant.sku;
      }

      setAddState(variant);
      syncStickyBar(variant);
      syncStock(variant);

      if (variant && variant.featured_media_id) showMedia(variant.featured_media_id);

      if (variant && variant.url && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }

      var err = root.querySelector('[data-st31-form-error]');
      if (err) { err.hidden = true; err.textContent = ''; }

      root.dispatchEvent(new CustomEvent('st31:variant:change', { detail: { variant: variant }, bubbles: true }));
    }

    if (addBtn && addLabel) addBtn.dataset.defaultLabel = addLabel.textContent.trim();

    // Reflect the initial variant without waiting for a change event
    (function () {
      var first = findVariant(selectedOptions());
      syncStock(first);
      syncStickyBar(first);
    })();

    root.addEventListener('change', function (e) {
      if (e.target.closest('.st31-variants__input')) update();
    });

    /* ------------------------------------------------------------ gallery */
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-st31-thumb]');
      if (thumb) { showMedia(thumb.getAttribute('data-st31-thumb')); return; }

      var zoom = e.target.closest('[data-st31-zoom]');
      if (zoom) { e.preventDefault(); openZoom(zoom.getAttribute('data-st31-zoom'), zoom.querySelector('img')); }
    });

    /* ----------------------------------------------------------- quantity */
    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-st31-qty-step]');
      if (!step) return;
      var input = root.querySelector('[data-st31-qty-input]');
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-st31-qty-step'), 10);
      input.value = Math.max(parseInt(input.min, 10) || 1, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* -------------------------------------------------------- ajax submit */
    if (form) {
      form.addEventListener('submit', function (e) {
        // When the merchant sends shoppers straight to checkout the form posts
        // normally and Shopify honours the return_to field.
        if (form.closest('[data-st31-direct-checkout]')) return;
        if (!window.st31 || !window.st31.cart) return; // let the browser post normally
        e.preventDefault();
        window.st31.cart.addFromForm(form);
      });
    }
  }

  /* -------------------------------------------------------------- lightbox */
  var zoomEl = null;

  function openZoom(src, sourceImg) {
    if (!src) return;
    closeZoom();

    zoomEl = document.createElement('div');
    zoomEl.className = 'st31-zoom';
    zoomEl.setAttribute('role', 'dialog');
    zoomEl.setAttribute('aria-modal', 'true');
    zoomEl.setAttribute('aria-label', (sourceImg && sourceImg.alt) || 'Product image');

    var img = document.createElement('img');
    img.src = src;
    img.alt = (sourceImg && sourceImg.alt) || '';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'st31-zoom__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';

    zoomEl.appendChild(close);
    zoomEl.appendChild(img);
    document.body.appendChild(zoomEl);
    document.documentElement.style.overflow = 'hidden';
    close.focus();

    zoomEl.addEventListener('click', function (e) {
      if (e.target === zoomEl || e.target === close) closeZoom();
    });
    document.addEventListener('keydown', onZoomKey);
  }

  function onZoomKey(e) { if (e.key === 'Escape') closeZoom(); }

  function closeZoom() {
    if (!zoomEl) return;
    zoomEl.remove();
    zoomEl = null;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onZoomKey);
  }


  /* ------------------------------------------------- recommendations */
  function initRecommendations() {
    var box = document.querySelector('[data-st31-recommendations]');
    if (!box || box.dataset.loaded === 'true') return;
    box.dataset.loaded = 'true';

    var url = box.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-st31-recommendations]');
        // Only swap when Shopify actually returned products, so any
        // fallback collection stays on screen otherwise.
        if (fresh && fresh.querySelector('.st31-card')) box.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('[data-st31-product]').forEach(initProduct);
    initRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();